<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>
  @if(codigoPropio){
    <app-filters filtros [name]="'filtros.moneda' | translate" [array]="tipoMoneda"
      [typeFilter]="Filters.ESCENARIOS" [click]="false" 
      (eventClick)="cambioTipoMoneda($event)">
    </app-filters> 
  }  
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <!-- ZONA IZQUIERDA TABLA GRAFICA -->
    <div class="zonaIzquierda">
      <!-- ZONA TABLA -->
      <div class="zonaTabla">
        <div class="w3-row w3-titulo-contenidomenuSC">
            <div class="headers w3-setenta textoOverFlow" style="width: 65%;">
              <span class="w3-margin-left-contenido">{{'liquidez.calces.titCalces' | translate}} | 
                @if(monedaSelec){{{'liquidez.calces.'+monedaSelec.tit | translate}}}
              </span>
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.periodo}}</span>
            </div>
            <div class="w3-rest w3-right">
              @if(verTablaCalce){
                <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen margenDer" [ngStyle]="{'color':'gray'}"
                (click)="grafCalce.showLabels = !grafCalce.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                  {{ grafCalce.showLabels ? 'label_off' : 'label' }}
                </mat-icon> 
                <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf(1)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
              }
              <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuTabla">
                more_vert
              </mat-icon>
              <mat-menu #menuTabla="matMenu">
                <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas1">
                  <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
                </button> 
                @if(verTablaCalce){
                  <button mat-menu-item (click)="cambiarGrafica('TABLA', 1)">
                    <mat-icon [ngStyle]="{'color':'gray'}">table</mat-icon>
                    <span>{{'graf.tabla'|translate}}</span>
                  </button>
                }
                <mat-divider/>
                @if(verTablaCalce){
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(1)">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar'|translate}}</span>
                  </button>        
                }@else{
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarTabla(1)">
                    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                    <span>{{'menu.Exportar'|translate}}</span>
                  </button>  
                }                             
              </mat-menu>
              <mat-menu #graficas1="matMenu">
                <button mat-menu-item  [ngClass]="{'w3-disabled': grafCalce.tipo === typeGrap.COMBO}" 
                [disabled]="grafCalce.tipo === typeGrap.COMBO"  (click)="cambiarGrafica('COMBO', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                  <span>{{'graf.combinada'|translate}}</span>
                </button>
                <button mat-menu-item [ngClass]="{'w3-disabled': grafCalce.tipo === typeGrap.AREA}" 
                [disabled]="grafCalce.tipo === typeGrap.AREA" (click)="cambiarGrafica('AREA', 1)">
                  <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                  <span>{{'graf.area'|translate}}</span>
                </button>
              </mat-menu>
            </div>            
        </div>
        @if(!verTablaCalce){
          <div class="w3-scroll" style="max-height: 92%;">          
            @if(verTabla){   
              <table class="tabla-aleema">
                <thead>
                  <tr>
                    @for (encabezados of tablaConfig.columnas; track $index) {
                      <th>
                        {{encabezados}}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (fila of tablaConfig.filas; track $index) {
                    @if (fila.visible && fila.type !== 'titulo' && fila.type !== 'blank') {
                      <tr>  
                        
                        @if(monedaSelec?.id == 1 || monedaSelec?.id == 2){
                          <td style="white-space: pre;"
                          [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                            @if(fila.type !== 'subtotal'){{{getCodigoPropio(fila?.sumar[0]) ?? ''}}}
                          </td>
                        }                   
                        @if(monedaSelec?.id == 1 || monedaSelec?.id == 3){
                          <td style="white-space: pre;"
                          [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                            @if(fila.type !== 'subtotal'){{{getCodigoPropio(fila?.sumar[1]) ?? '-'}}}
                          </td>
                        }
                        
                        <td style="white-space: pre;"
                        [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                          @if (fila.expandible){
                            <mat-icon class="iconoMen" (click)="showAndHide(fila)">
                              {{fila.expandido?'expand_less':'expand_more'}}
                            </mat-icon>
                          } 
                          {{fila.descripcion}}
                        </td>
                        @for (banda of fila.bandasValue; track $index) {
                          <td class="alinRight"
                          [ngClass]="{
                            'bordersNoLaterales': banda === null,
                            'total': fila.type === 'subtotal' || fila.suma
                          }">
                            {{banda | formaterNumber:fila.decimales??2:',':'.'}}
                          </td>
                        }
                      </tr>
                    }@else if(fila.type === 'titulo'){
                      <tr>
                        <td class="w3-elemento-titulo-table" [colSpan]="monedaSelec.id == 1 ? 3 : 2 ">
                          {{fila.descripcion}}
                        </td>
                        @for (banda of fila.bandasValue; track $index) {
                          <td class="alinRight">
                            {{banda | formaterNumber:fila.decimales??2:',':'.'}}
                          </td>
                        }
                      </tr>
                    }@else if(fila.type === 'blank'){
                      <tr style="height: 15px;">
                        <td [colSpan]="(fila.bandas.length+3)">
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>       
            }@else{<app-skeleton-table [columnas]="13" [filas]="6"/>}       
          </div>    
        }@else{
          <div style="height: 86%;">
            @if(grafCalce.data.length > 0){
              <app-graficador
                [data]="grafCalce.data"
                [labels]="grafCalce.etiquetas"
                [type]="grafCalce.tipo"
                [colors]="colores"
                [axisY]="['Calce descalce', 'Millones']"
                [axisX]=""
                [zona]="1"
                [legend]="{enabled: true, position: 'bottom'}"
                [etiquetas]="grafCalce.showLabels"
                [formatEtiquetas]="true"
                [setTwoLast]="true"
                [animations]="true"
                [alinearYIzquierda]="true"
                [stroke]="true">
              </app-graficador>
            }@else {<app-skeleton-grafica />}  
          </div>  
        }        
      </div>
      <!-- ZONA GRAFICA -->
      <div class="zonaGrafica">
        <div class="w3-row w3-titulo-contenidomenuSC">
          <div class="headers w3-setenta textoOverFlow" style="width: 65%;">
            <span class="w3-margin-left-contenido">{{'liquidez.calces.titFEC' | translate}} | 
               @if(monedaSelec){{{'liquidez.calces.'+monedaSelec.tit | translate}}}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.periodo}}</span>
          </div>
          <div class="w3-rest w3-right">            
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuFEC">
              more_vert
            </mat-icon>
            <mat-menu #menuFEC="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarTabla(3)">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>  
            </mat-menu>            
          </div>            
        </div>
        <div class="w3-scroll" style="height: 40vh;">
          @if(tablaFEC){          
            <table class="tabla-aleema">
              <thead>
                <tr>
                  @for (encabezados of tablaFEC.columnas; track $index) {
                    <th>{{encabezados}}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (fila of tablaFEC.filas; track $index) {
                  @if (fila.visible && fila.type !== 'titulo' && fila.type !== 'blank') {
                    <tr>                          
                      <td style="white-space: pre;"
                      [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                        {{fila.descripcion}}
                      </td>
                      @for (banda of fila.bandasValue; track $index) {
                        <td class="alinRight"
                        [ngClass]="{
                          'bordersNoLaterales': banda === null,
                          'total': fila.type === 'subtotal' || fila.suma
                        }">
                          {{banda | formaterNumber:fila.decimales??2:',':'.'}}
                        </td>
                      }
                    </tr>
                  }@else if(fila.type === 'titulo'){
                    <tr>
                      <td class="w3-elemento-titulo-table" [colSpan]="monedaSelec.id == 1 ? 3 : 2 ">
                        {{fila.descripcion}}
                      </td>
                      @for (banda of fila.bandasValue; track $index) {
                        <td class="alinRight">
                          {{banda | formaterNumber:fila.decimales??2:',':'.'}}
                        </td>
                      }
                    </tr>
                  }@else if(fila.type === 'blank'){
                    <tr style="height: 15px;">
                      <td [colSpan]="(fila.bandas.length+3)">
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          }@else{<app-skeleton-table [columnas]="13" [filas]="6"/>} 
        </div>        
      </div>  
    </div>    
    <!-- ZONA DERECHA GRAFICAS -->
    <div class="zonaDerecha">
      <div class="grafica">
        <div class="w3-row w3-titulo-contenidomenuSC">
          <div class="headers w3-setenta textoOverFlow" style="width: 70%;">
            <span class="w3-margin-left-contenido">{{'liquidez.calces.titComposicion' | translate}} | 
               @if(monedaSelec){{{'liquidez.calces.'+monedaSelec.tit | translate}}}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.periodo}}</span>
          </div>
          <div class="w3-rest w3-right">
            @if(!verTablaComp){
              <mat-icon fontSet="material-icons-outlined" class="w3-row w3-rigth w3-button iconoMen margenDer" [ngStyle]="{'color':'gray'}"
              (click)="grafComposicion.showLabels = !grafComposicion.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                {{ grafComposicion.showLabels ? 'label_off' : 'label' }}
              </mat-icon> 
              <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="ampliarGraf(2)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                zoom_out_map
              </mat-icon>  
            }            
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGraf2">
              more_vert
            </mat-icon>
            <mat-menu #menuGraf2="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas2">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
              </button> 
              <mat-divider></mat-divider>
              @if(!verTablaComp){
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button>  
              }@else {
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarTabla(2)">
                  <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar'|translate}}</span>
                </button> 
              }              
            </mat-menu>
            <mat-menu #graficas2="matMenu">
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafComposicion.tipo === typeGrap.DONUT}" 
              [disabled]="grafComposicion.tipo === typeGrap.DONUT"  (click)="cambiarGrafica('DONUT', 2)">
                <mat-icon [ngStyle]="{'color':'gray'}">pie_chart</mat-icon>
                <span>{{'graf.pie'|translate}}</span>
              </button>
              <!-- <button mat-menu-item [ngClass]="{'w3-disabled': grafComposicion.tipo === typeGrap.HEATMAP}" 
              [disabled]="grafComposicion.tipo === typeGrap.HEATMAP" (click)="cambiarGrafica('HEATMAP', 2)">
                <mat-icon [ngStyle]="{'color':'gray'}">dashboard_2</mat-icon>
                <span>{{'graf.calor'|translate}}</span>
              </button> -->
              <button mat-menu-item  [ngClass]="{'w3-disabled': verTablaComp}" 
              [disabled]="verTablaComp"  (click)="cambiarGrafica('TABLA', 2)">
                <mat-icon [ngStyle]="{'color':'gray'}">table</mat-icon>
                <span>{{'graf.tabla'|translate}}</span>
              </button>
            </mat-menu>
          </div>            
        </div>
        <div style="height: 84%;">
          @if(!verTablaComp){
            @if(grafComposicion.data.length > 0){
              <app-graficador
                [data]="grafComposicion.data"
                [labels]="grafComposicion.etiquetas"
                [type]="grafComposicion.tipo"
                [colors]="colores"
                [axisY]="['', '']"
                [axisX]=""
                [zona]="2"
                [legend]="{enabled: true, position: 'right'}"
                [porcentaje]="true"
                [etiquetas]="grafComposicion.showLabels"
                [formatEtiquetas]="false"
                [animations]="true"
                [alinearYIzquierda]="true"
                [stroke]="false">
              </app-graficador>
            }@else {<app-skeleton-grafica />}  
          }@else{
            <div class="tab">
              @if(dataComposicion.length > 0){
                <table class="tabla-aleema">
                  <thead>
                    <tr>
                      <th>{{'liquidez.calces.descripcion' | translate}}</th>
                      <th>{{'liquidez.calces.mn' | translate}}</th>
                      <th>{{'liquidez.calces.me' | translate}}</th>
                      <th>{{'liquidez.calces.total' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for(d of dataComposicion; track $index){
                      <tr>
                        <td>{{d.descripcion}}</td>
                        <td class="alinRight">{{d.mn | formaterNumber:2:',':'.'}}</td>
                        <td class="alinRight">{{d.me | formaterNumber:2:',':'.'}}</td>
                        <td class="alinRight">{{d.total | formaterNumber:2:',':'.'}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }@else{<app-skeleton-table [columnas]="4" [filas]="6"/>}              
            </div>
          }          
        </div>
      </div>
      <div class="grafica">
        <div class="w3-row w3-titulo-contenidomenuSC">
          <div class="headers w3-setenta textoOverFlow" style="width: 75%;">
            <span class="w3-margin-left-contenido">{{grafActivos.titulo}}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.periodo}}</span>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen margenDer" [ngStyle]="{'color':'gray'}"
            (click)="grafActivos.showLabels = !grafActivos.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafActivos.showLabels ? 'label_off' : 'label' }}
            </mat-icon> 
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="ampliarGraf(3)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGraf3">
              more_vert
            </mat-icon>
            <mat-menu #menuGraf3="matMenu">              
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas3">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
              </button> 
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="bandasMenu">
                <span>{{titBanda}}</span>
              </button> 
              <mat-divider></mat-divider>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(3)">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>  
              
            </mat-menu>
            <mat-menu #bandasMenu="matMenu">
              @for(b of bandas; track $index){
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambiarBanda(b)">
                  <span>{{b.opcion}}</span>
                </button> 
              }
            </mat-menu>
            <mat-menu #graficas3="matMenu">
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafActivos.tipo === typeGrap.BARHORIZONTAL}" 
              [disabled]="grafActivos.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGrafica('BARHORIZONTAL', 3)">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'graf.horizontal'|translate}}</span>
              </button>
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafActivos.tipo === typeGrap.LINE}" 
              [disabled]="grafActivos.tipo === typeGrap.LINE"  (click)="cambiarGrafica('LINE', 3)">
                <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'graf.lineal'|translate}}</span>
              </button>
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafActivos.tipo === typeGrap.AREA}" 
              [disabled]="grafActivos.tipo === typeGrap.AREA"  (click)="cambiarGrafica('AREA', 3)">
                <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'graf.area'|translate}}</span>
              </button>
            </mat-menu>
          </div>            
        </div>
        <div style="height: 84%;">
          @if(grafActivos.data.length > 0){
            <app-graficador
              [data]="grafActivos.data"
              [labels]="grafActivos.etiquetas"
              [type]="grafActivos.tipo"
              [colors]="colores"
              [axisY]="['']"
              [axisX]=""
              [zona]="3"
              [legend]="{enabled: false, position: 'right'}"
              [etiquetas]="grafActivos.showLabels"
              [formatEtiquetas]="true"
              [animations]="true"
              [distributed]="true"
              [alinearYIzquierda]="true"
              [stroke]="false"
              [agruparCategoriasExcedentes]="true"
              [maxCategoriasVisibles]="5"
              [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
              [ordenCategorias]="'descendente'">
            </app-graficador>
          }@else {<app-skeleton-grafica />}  
          
        </div>
      </div>
      <div class="grafica">
        <div class="w3-row w3-titulo-contenidomenuSC">
          <div class="headers w3-setenta textoOverFlow" style="width: 75%;">
            <span class="w3-margin-left-contenido">{{grafPasivos.titulo}}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo"> {{periodoSeleccionado?.periodo}}</span>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen margenDer" [ngStyle]="{'color':'gray'}"
            (click)="grafPasivos.showLabels = !grafPasivos.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafPasivos.showLabels ? 'label_off' : 'label' }}
            </mat-icon> 
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="ampliarGraf(4)" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGraf4">
              more_vert
            </mat-icon>
            <mat-menu #menuGraf4="matMenu">              
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="graficas4">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
              </button> 
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="bandasMenu">
                <span>{{titBanda}}</span>
              </button> 
              <mat-divider></mat-divider>
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica(4)">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>  
              
            </mat-menu>
            <mat-menu #graficas4="matMenu">
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafPasivos.tipo === typeGrap.BARHORIZONTAL}" 
              [disabled]="grafPasivos.tipo === typeGrap.BARHORIZONTAL"  (click)="cambiarGrafica('BARHORIZONTAL', 4)">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'graf.horizontal'|translate}}</span>
              </button>
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafPasivos.tipo === typeGrap.LINE}" 
              [disabled]="grafPasivos.tipo === typeGrap.LINE"  (click)="cambiarGrafica('LINE', 4)">
                <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'graf.lineal'|translate}}</span>
              </button>
              <button mat-menu-item  [ngClass]="{'w3-disabled': grafPasivos.tipo === typeGrap.AREA}" 
              [disabled]="grafPasivos.tipo === typeGrap.AREA"  (click)="cambiarGrafica('AREA', 4)">
                <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'graf.area'|translate}}</span>
              </button>
            </mat-menu>
          </div>            
        </div>
        <div style="height: 84%;">
          @if(grafPasivos.data.length > 0){
            <app-graficador
              [data]="grafPasivos.data"
              [labels]="grafPasivos.etiquetas"
              [type]="grafPasivos.tipo"
              [colors]="colores"
              [axisY]="['']"
              [axisX]=""
              [zona]="4"
              [legend]="{enabled: false, position: 'right'}"
              [etiquetas]="grafPasivos.showLabels"
              [formatEtiquetas]="true"
              [animations]="true"
              [distributed]="true"
              [alinearYIzquierda]="true"
              [stroke]="false"
              [agruparCategoriasExcedentes]="true"
              [maxCategoriasVisibles]="5"
              [etiquetaOtros]="'segPresupuestal.estadoFinanciero.otros' | translate"
              [ordenCategorias]="'descendente'">
            </app-graficador>
          }@else {<app-skeleton-grafica />}  
          
        </div>
      </div>
    </div>
  </div>
</app-esqueleto-tableros>
<!--Modal ampliar grafica-->
<app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{tituloModal}} </span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ subtituloModal }}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          @if (graficaAmp === 1) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="grafCalce.showLabels= !grafCalce.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafCalce.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 2) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="grafComposicion.showLabels = !grafComposicion.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafComposicion.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }          
          @if (graficaAmp === 3) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="grafActivos.showLabels = !grafActivos.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafActivos.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }          
          @if (graficaAmp === 4) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="grafPasivos.showLabels = !grafPasivos.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafPasivos.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }          
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(graficaAmp)" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body style="height: 60vh;">
    <!--area grafica-->
    <div style="width: 100%;" >
      <div class="w3-row" style="height: 58vh;">
        @if (modalOpen) {
          @if(graficaAmp === 1){
            <app-graficador
              [data]="grafCalce.data"
              [labels]="grafCalce.etiquetas"
              [type]="grafCalce.tipo"
              [colors]="colores"
              [axisY]="['', 'Millones']"
              [axisX]=""
              [zona]="5"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="grafCalce.showLabels"
              [formatEtiquetas]="true"
              [setTwoLast]="true"
              [animations]="true"
              [alinearYIzquierda]="true"
              [stroke]="false">
            </app-graficador>
          }
          @if(graficaAmp === 2){
            <app-graficador
              [data]="grafComposicion.data"
              [labels]="grafComposicion.etiquetas"
              [type]="grafComposicion.tipo"
              [colors]="colores"
              [axisY]="['', '']"
              [axisX]=""
              [zona]="6"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="grafComposicion.showLabels"
              [formatEtiquetas]="true"
              [animations]="true"
              [alinearYIzquierda]="true"
              [stroke]="false">
            </app-graficador>
          }
          @if(graficaAmp === 3){
            <app-graficador
              [data]="grafActivos.data"
              [labels]="grafActivos.etiquetas"
              [type]="grafActivos.tipo"
              [colors]="colores"
              [axisY]="['']"
              [axisX]=""
              [zona]="7"
              [legend]="{enabled: false, position: 'right'}"
              [etiquetas]="grafActivos.showLabels"
              [formatEtiquetas]="true"
              [animations]="true"
              [distributed]="true"
              [alinearYIzquierda]="true"
              [stroke]="false"
              [ordenCategorias]="'descendente'">
            </app-graficador>
          }          
          @if(graficaAmp === 4){
            <app-graficador
              [data]="grafPasivos.data"
              [labels]="grafPasivos.etiquetas"
              [type]="grafPasivos.tipo"
              [colors]="colores"
              [axisY]="['']"
              [axisX]=""
              [zona]="8"
              [legend]="{enabled: false, position: 'right'}"
              [etiquetas]="grafPasivos.showLabels"
              [formatEtiquetas]="true"
              [animations]="true"
              [distributed]="true"
              [alinearYIzquierda]="true"
              [stroke]="false"
              [ordenCategorias]="'descendente'">
            </app-graficador>
          }          
        }
      </div>
    </div>
  </div>
</app-modal>